// KBT-188 — what the Membership page says about the season's renewal
// timeline. Reads the `rollout` block the backend adds to
// GET /api/membership/seat-lock-info (kbt-backend
// membership/rolloutSchedule.js). Returns null — no banner, page unchanged
// — outside the renewal season or when the backend doesn't send it.

const formatDate = (dateOnly) =>
  new Date(`${dateOnly}T12:00:00Z`).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });

export const SIGN_IN_TO_RENEW_HREF = `/signin?next=${encodeURIComponent('/membership2026')}`;

export const getRolloutBanner = (rollout, { signedIn = false } = {}) => {
  if (!rollout || !rollout.phase) return null;
  const earlyCommit = rollout.earlyCommitDeadline ? formatDate(rollout.earlyCommitDeadline) : null;

  if (rollout.phase === 'member_priority') {
    return {
      kind: 'member_priority',
      title: `Members-only renewal window for ${rollout.cycle}`,
      body: `Returning members renew first. Renew by ${earlyCommit} for first choice of High Holiday seats — enrollment and guest seats open to everyone on ${earlyCommit}.`,
      cta: signedIn ? null : { label: 'Sign in to renew', href: SIGN_IN_TO_RENEW_HREF },
    };
  }

  if (rollout.phase === 'pre_season' && rollout.renewalNoticesDue && rollout.priorityWindowStart) {
    const windowOpens = formatDate(rollout.priorityWindowStart);
    return {
      kind: 'renewal_soon',
      title: `Membership renewal for ${rollout.cycle} opens ${windowOpens}`,
      body: `Returning members get a members-only window from ${windowOpens}. Commit by ${earlyCommit} for first choice of High Holiday seats.`,
      cta: signedIn ? null : { label: 'Sign in', href: SIGN_IN_TO_RENEW_HREF },
    };
  }

  return null;
};
